import React from 'react';
import LibraryContextSelectContainer from './LibraryContextSelectContainer';
import {FeedbackTriggerType, LibraryAccessType} from 'records/FeedbackTrigger';
import LibraryStore from 'stores/library/LibraryStore';
import LibraryActions from 'actions/library/LibraryActions';
import connectToStores from 'alt-utils/lib/connectToStores';
import TriggerIconButton from 'components/triggers/TriggerIconButton';
import './LibraryContextView.styl';
import classnames from 'classnames';
import {CircleXIcon} from '@components/icon/CircleXIcon';
import {CogIcon} from '@components/icon/CogIcon';

class LibraryContextView extends React.Component {
  constructor(props) {
    super(props);

    this.saveSelection = this.saveSelection.bind(this);
    this.toggleSelection = this.toggleSelection.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.state = {
      previousContext: null,
    };
  }

  static getStores() {
    return [LibraryStore];
  }

  static getPropsFromStores(nextProps) {
    const {context} = nextProps;
    const libraries = LibraryStore.getState().sources.get('libraries') || [];
    // == on purpose cuz i want "1" == 1
    const library = context && libraries.find(l => l.id === context.library_id);
    return {library};
  }

  componentDidMount() {
    const {context} = this.props;
    const libraries = LibraryStore.getState().sources.get('libraries');
    if (libraries === null || libraries === undefined) {
      LibraryActions.getLibraries.defer();
    }
    if (context === null || context === undefined) {
      this.props.updateSelectionVisible(oldValue => true);
    }
  }

  removeItem() {
    this.props.updateSelectionVisible(oldValue => false);
    this.setState({
      previousContext: null,
    });
    this.props.removeItem();
  }

  toggleSelection() {
    this.props.updateSelectionVisible(oldValue => !oldValue);
  }

  saveSelection(context) {
    this.props.updateSelectionVisible(oldValue => false);
    this.props.saveSelection(context);
  }

  getSelectedLibraryType(context) {
    if (!context) {
      return null;
    }

    if (context.type === FeedbackTriggerType.LIBRARY_ACCESS) {
      return context.matching;
    } else {
      return context.type;
    }
  }

  getLibraryTypeDescription(context, library) {
    if (context.type === FeedbackTriggerType.LIBRARY_ACCESS) {
      // eslint-disable-next-line
      switch (context.matching) {
        case LibraryAccessType.ANY_LIBRARY:
          return (
            <span className="condition-action" onClick={this.toggleSelection}>
              and they added to any library
            </span>
          );
        case LibraryAccessType.LIBRARY_I_CREATED:
          return (
            <span className="condition-action" onClick={this.toggleSelection}>
              and they added to any library I created
            </span>
          );
        case LibraryAccessType.LIBRARY_I_CAN_VIEW:
          return (
            <span className="condition-action" onClick={this.toggleSelection}>
              and they added to any library I can view
            </span>
          );
        case LibraryAccessType.LIBRARY_I_ADMIN:
          return (
            <span className="condition-action" onClick={this.toggleSelection}>
              and they added to any library I admin
            </span>
          );
      }
    } else {
      // eslint-disable-next-line
      switch (context.type) {
        case FeedbackTriggerType.ADDS_TO_LIBRARY:
          return (
            <span>
              and they added to library:{' '}
              <span className="condition-action" onClick={this.toggleSelection}>
                '{(library && library.name) || context.library_id}'
              </span>
            </span>
          );
        case FeedbackTriggerType.LIBRARY_TAG:
          return (
            <span>
              and they tagged the call:{' '}
              <span className="condition-action" onClick={this.toggleSelection}>
                '{context.tag_name}'
              </span>
            </span>
          );
      }
    }
  }

  render() {
    const {context, library, selectionVisible} = this.props;
    const showButton =
      !context ||
      (context.type === FeedbackTriggerType.LIBRARY_ACCESS &&
        context.matching === LibraryAccessType.ANY_LIBRARY);
    const selectedType = this.getSelectedLibraryType(context);
    return (
      <div className={classnames(!showButton && 'feedback-rule-type-select', 'feedback-option')}>
        <div className="rule-context">
          <div className="library-context-view">
            {showButton && (
              <TriggerIconButton
                active={selectionVisible}
                label={'Optional: Specify library'}
                onClick={this.toggleSelection}
                icon={<CogIcon tooltip="Edit" />}
              />
            )}
            {!showButton && (
              <div className="rule-option-list ">
                <ul>
                  <li>
                    <div className="context-item">
                      {this.getLibraryTypeDescription(context, library)}
                    </div>
                    <div className="delete" onClick={this.removeItem}>
                      <CircleXIcon tooltip="Remove" />
                    </div>
                  </li>
                </ul>
              </div>
            )}
            {selectionVisible && (
              <div className="create-rule-popout edit-popout">
                <LibraryContextSelectContainer
                  saveSelection={this.saveSelection}
                  closeOnSelect={false}
                  closeRequest={this.toggleSelection}
                  selectedContextType={selectedType}
                  selectedValue={context && context.getValue()}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connectToStores(LibraryContextView);
